export default __webpack_public_path__ + "static/media/setting-5.af944453.svg";